import { configureStore } from '@reduxjs/toolkit';
import createReducer from './rootReducer';
import { createLogger } from 'redux-logger';
import { rtkQueryErrorLogger } from './middlewares/rtkQueryErrorHandler';
import { apiSlice } from '../api/apiSlice';

if (import.meta.env.DEV && import.meta.hot) {
  import.meta.hot.accept('./rootReducer', () => {
    const newRootReducer = createReducer.default;
    store.replaceReducer(newRootReducer.createReducer());
  });
}

const middlewares = [rtkQueryErrorLogger, apiSlice.middleware];

if (import.meta.env.DEV) {
  const logger = createLogger({ collapsed: (getState, action, logEntry) => !logEntry.error });

  middlewares.push(logger);
}

const store = configureStore({
  reducer: createReducer(),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(middlewares),
  devTools: import.meta.env.DEV,
});

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
  if (store.asyncReducers[key]) {
    return false;
  }
  store.asyncReducers[key] = reducer;
  store.replaceReducer(createReducer(store.asyncReducers));
  return store;
};

export default store;
